import AddCollegeRanking from "../../Components/Modals/AddCollegeRanking";
import Table from "../../Components/Table";
import { deleteCollegeRankingById, getAllCollegeRanking } from "../../Services/CollegeService";

const CollegeRanking = () => {
    const columns = [
        {
            label: "College Name",
            value: "college_name"
        },
        {
            label: "Ranking By",
            value: "ranking_given_by"
        },
        {
            label: "Ranking From",
            value: "ranking_from"
        },
        {
            label: "Ranking To",
            value: "ranking_to"
        },
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddCollegeRanking data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllCollegeRanking}
            columns={columns}
            title={"College Ranking"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteCollegeRankingById}
        />
    );
}

export default CollegeRanking;